import ILink from '../ILink';
import IUrl, { ISonURL } from '../IUrl';
import { ProfileImageSmall } from './ImageType';

// type from userService
export type ExistingUserProfile = {
  profileName: string;
  profileLink: ILink;
  personInfoCardUrl: IUrl;
  profileImageUrl: ProfileImageSmall;

  phoneLink?: ISonURL;
  emailLink?: ISonURL;
};

type DeletedUserProfile = {
  profileName: string;
  profileImageUrl: ProfileImageSmall;
  deletedUser: true;
};

export type UserProfile = DeletedUserProfile | ExistingUserProfile;

export function isDeletedUser(user: UserProfile): user is DeletedUserProfile {
  return (user as DeletedUserProfile)?.deletedUser;
}
